import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { mapBadges } from "./map-badges";
import { CommunicationMarkNotificationBadgesAsSeenDocument } from "./mark-notification-badges-as-seen.gql-types";
const useZerofyNotificationBadges = () => {
  const [markAsSeen] = useMutation(CommunicationMarkNotificationBadgesAsSeenDocument);
  const markBadgesAsSeen = useCallback((badges) => markAsSeen({ variables: { badges: { badgeNames: mapBadges(badges) } } }), [markAsSeen]);
  return { markBadgesAsSeen };
};
export {
  useZerofyNotificationBadges
};
